import React, { useEffect, useState } from 'react';
import propTypes from 'prop-types';
import { formatRtsCountdown, RTS_OVERDUE_LABEL } from '../../../helpers/saleCursorPagination';

const listeners = new Set();
let sharedTimer = null;

const subscribeRtsTick = (listener) => {
  listeners.add(listener);
  if (sharedTimer == null) {
    sharedTimer = setInterval(() => {
      listeners.forEach((fn) => fn());
    }, 1000);
  }
  return () => {
    listeners.delete(listener);
    if (listeners.size === 0 && sharedTimer != null) {
      clearInterval(sharedTimer);
      sharedTimer = null;
    }
  };
};

const RtsCountdown = ({ expiresAt, initialLabel }) => {
  const [label, setLabel] = useState(() => (
    initialLabel === undefined ? formatRtsCountdown(expiresAt) : initialLabel
  ));

  useEffect(() => {
    const initial = initialLabel === undefined ? formatRtsCountdown(expiresAt) : initialLabel;
    setLabel(initial);
    if (initial == null || initial === RTS_OVERDUE_LABEL) return undefined;

    let unsubscribe = () => {};
    const tick = () => {
      const next = formatRtsCountdown(expiresAt);
      setLabel(next);
      if (next == null || next === RTS_OVERDUE_LABEL) unsubscribe();
    };
    unsubscribe = subscribeRtsTick(tick);
    return unsubscribe;
  }, [expiresAt, initialLabel]);

  if (label == null) return null;
  return <span>{label}</span>;
};

RtsCountdown.propTypes = {
  expiresAt: propTypes.string,
  initialLabel: propTypes.string,
};

RtsCountdown.defaultProps = {
  expiresAt: null,
  initialLabel: undefined,
};

export default RtsCountdown;
